// The workspace list from users/me (US 9436).
// For super admins the list holds every client, so the response is kept small: a partition names its
// parent ({ id, name, slug }) instead of embedding it, and only the open workspace brings its logo.

// Ask users/me for the open workspace, so its logo is in the list
export function userMeParams(params) {
  return Object.assign({ current: localStorage.getItem('client') || undefined }, params || {});
}

// Point each partition at the full parent from the same list again, so a partition's parent can be
// opened as a workspace (the sidebar's "Back to client") with all its fields
export function linkParents(clients) {
  let byId = {};
  (clients || []).forEach(client => { byId[client.id] = client; });
  (clients || []).forEach(client => {
    if (client.parent && byId[client.parent.id] && client.parent !== byId[client.parent.id]) {
      client.parent = byId[client.parent.id];
    }
  });
  return clients;
}
